import { AuthResponseDTO, AuthSessionApi } from '@arbihunter/api-client';
import { Console, Effect, pipe } from 'effect';
import { api } from 'shared/api';
export { AuthResponseDTO } from '@arbihunter/api-client';

export const refreshAccessToken = (): Effect.Effect<AuthResponseDTO, Error> => {
  return pipe(
    Effect.tryPromise({
      try: () => api.run(AuthSessionApi).refresh0(),
      catch: (error) => Error(error.toString()),
    }),
    Effect.tap((data) => console.log('[refreshAccessToken] API call result:', data)),
    Effect.onError((error) => Console.error('[refreshAccessToken] Error occurred:', error)),
  );
};
